import clsx from 'clsx'
import { useUser } from 'hooks/user'
import { ReactComponent as LogoSvg } from 'images/logo_main.svg'
import { useTranslation } from 'react-i18next'
import { Link, useMatch } from 'react-router-dom'
import { PATH } from 'utils/constants'

import User from './components/User/User'

import style from '../Header.module.css'

const MainHeader = () => {
  const { t } = useTranslation()
  const tabMissionControl = useMatch(`${PATH.MISSION_CONTROL}/*`)
  const tabFacilities = useMatch(`${PATH.FACILITY_LIST}/*`)
  const tabAssets = useMatch(`/`)
  const tabStations = useMatch(`${PATH.STATION_LIST}/*`)
  const tabRecordedRoutes = useMatch(`${PATH.RECORDED_ROUTE_LIST}/*`)
  const tabMissionPlanner = useMatch(`${PATH.MISSION_LIST}/*`)
  const tabScenario = useMatch(`${PATH.SCENARIO_LIST}/*`)
  const tabMaps = useMatch(`${PATH.MAP_LIST}`)
  const tabScheduler = useMatch(`${PATH.TASKS}`)
  const tabDashboard = useMatch(`${PATH.DASHBOARD}`)
  const user = useUser()

  return (
    <div className={style.header}>
      <Link to={PATH.ASSET_LIST} className={style.logo}>
        <LogoSvg />
      </Link>
      <div className={style.middle}>
        <div className={style.middleLinksBlock}>
          {tabMissionControl && (
            <div className={clsx(style.link, style.noCursor, style.active)}>{t('header.mission_control')}</div>
          )}
          <Link to={PATH.FACILITY_LIST} className={clsx(style.link, { [style.active]: tabFacilities })}>
            {t('header.facilities')}
          </Link>
          <Link to={PATH.ASSET_LIST} className={clsx(style.link, { [style.active]: tabAssets })}>
            {t('header.assets')}
          </Link>
          {/* <Link to={PATH.STATION_LIST} className={clsx(style.link, { [style.active]: tabStations })}>
            {t('header.stations')}
          </Link> */}
          <Link to={PATH.SCENARIO_LIST} className={clsx(style.link, { [style.active]: tabScenario })}>
            {t('header.scenarios')}
          </Link>
          <Link to={PATH.MISSION_LIST} className={clsx(style.link, { [style.active]: tabMissionPlanner })}>
            {t('header.missions')}
          </Link>
          <Link to={PATH.TASKS} className={clsx(style.link, { [style.active]: tabScheduler })}>
            {t('header.schedule')}
          </Link>
          <Link to={PATH.DASHBOARD} className={clsx(style.link, { [style.active]: tabDashboard })}>
            {t('header.dashboard')}
          </Link>
          <Link to={PATH.RECORDED_ROUTE_LIST} className={clsx(style.link, { [style.active]: tabRecordedRoutes })}>
            {t('header.recorded_routes')}
          </Link>
          {/* <Link to={PATH.MAP_LIST} className={clsx(style.link, { [style.active]: tabMaps })}>
            {t('header.maps')}
          </Link> */}
        </div>
      </div>
      <div className={style.user}>
        <User email={user?.state.email} firstName={user?.state.firstName} lastName={user?.state.lastName} />
      </div>
    </div>
  )
}
export default MainHeader
